import { Navigate, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import Header from './components/layout/Header/Header';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import NewCustomerPage from './pages/NewCustomer/NewCustomerPage';
import styles from './App.module.css';
import UserContext from './context/user-context';
import CustomerDashboard from './pages/CustomerDashboard/CustomerDashboard';
import RepresentativePage from './pages/Representative/RepresentativePage';
import QuestionnaireHistory
  from './components/customer/ServiceInformation/Questionnaire/QuestionnaireHistory';
import RequireAuth from './components/auth/RequireAuth';
import QuestionnaireView
  from './components/customer/ServiceInformation/Questionnaire/QuestionnaireView';
import AccessDenied from './pages/Login/AccessDenied';
import CustomerSearchResultTable from './components/customer/Search/CustomerSearchResultTable';

function App() {
  const userCtx = useContext(UserContext);

  return (
    <div>
      <Header />
      <main className={styles.container}>
        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/login' element={userCtx.isLoggedIn ? <Navigate to='/' /> : <Login />} />
          <Route path='/denied' element={<AccessDenied />} />
          <Route element={<RequireAuth isLoggedIn={userCtx.isLoggedIn} />}>
            <Route path='/private' element={
              <NewCustomerPage customerType='PRIVATE' />
            } />
            <Route path='/legal' element={
              <NewCustomerPage customerType='LEGAL' />
            } />
            <Route path='/search' element={
              <CustomerSearchResultTable />
            } />
            <Route path='/customer' element={
              <CustomerDashboard />
            } />
            <Route path='/customer/representative' element={
              <RepresentativePage />
            } />
            <Route path='/customer/history' element={<QuestionnaireHistory />} />
            <Route path='/customer/questionnaire' element={<QuestionnaireView />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

export default App;
